.jx{pointer-events:auto;}